import { publicActions } from "@common/redux/public/actions";
import { IPublicReducerState } from "@common/redux/public/interface";

export const initialState = {
  redirectionPathAfterAuth: "",
};

export const publicReducer = (
  state: IPublicReducerState = initialState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case publicActions.SET_REDIRECT_PATH_AFTER_AUTH:
      return {
        ...state,
        redirectionPathAfterAuth: action.payload,
      };
    default:
      return { ...state };
  }
};
